import { SITE_CONFIG_API_URL } from '@config/constants';
import type { SiteConfigResponse } from './types';

const localToDevHostnameMap: Record<string, string> = {
  'local.checkout.wiley.com': 'dev.store.wiley.com',
  'local.graphicstandards.com': 'dev.graphicstandards.com',
  'local.vetdev.wiley.com': 'vetdev.wiley.com',
  'local.spectrabase.com': 'dev.spectrabase.com',
};

export type GetSiteConfig = (hostUrl?: string) => Promise<SiteConfigResponse
| null>;

export const getSiteConfig: GetSiteConfig = async (hostUrl) => {
  let hostname = hostUrl ? hostUrl.split('//')[1] : window.location.hostname;

  // Replace local hostnames with their dev values as the SiteConfig API does not support local hostnames
  if (Object.keys(localToDevHostnameMap).includes(hostname)) {
    hostname = localToDevHostnameMap[hostname];
  }

  const encodedDomain = btoa(hostname);
  const apiUrl = `${SITE_CONFIG_API_URL}?domain=${encodedDomain}`;
  try {
    const res = await fetch(apiUrl);
    const config = await res.json();

    if (!config) {
      throw new Error('Site config not returned from API');
    }

    return config;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Failed to fetch site config:', error);
    return null;
  }
};
